<template>
    <span class="sub-header">
        {{ matchSummary }}
    </span>
</template>

<script>
    import { HubConnection } from '@aspnet/signalr';

    export default {
        name: 'MatchSummary',
        data() {
            return {
                matchSummary: null
            }
        },
        props: {
            connection: HubConnection,
            sport: String,
            eventId: String,
            state: Array
        },
        methods: {
            updateGamestate(updatedGamestate) {
                if (updatedGamestate !== null) {
                    this.matchSummary = updatedGamestate && updatedGamestate.GameState[0].MatchSummary;
                }
            },
        },
        mounted() {
            if (this.connection) {
                this.connection.on(this.eventId + "_fixtureUpdate", (value) => {
                    this.updateGamestate(JSON.parse(value));
                });
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
